import { z } from "zod";
import { isNotNullNotUndefined } from "../helpers/utilities.js";
const groupIdSchema = z.uuid().brand();
function asGroupId(id) {
  return groupIdSchema.parse(id);
}
function checkIsManagerGroup(group) {
  return isNotNullNotUndefined(group.manager_id);
}
function toTeammateGroupPublicApi(group) {
  return {
    id: group.id,
    name: group.name,
    teammate_ids: group.teammate_ids
  };
}
export {
  asGroupId,
  checkIsManagerGroup,
  groupIdSchema,
  toTeammateGroupPublicApi
};
//# sourceMappingURL=group.js.map
